import { css } from '@emotion/react'

const styles = () => {
    return { wrapper: css`
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        ` }
}

export default styles
